<script lang="ts">
	import { createEventDispatcher } from 'svelte';

	import type { ApplianceType } from 'src/helpers/device_settings_helpers';

	import EnergyCategoryTypePicker from 'src/components/DevicesSettings/Settings/CommonSettings/EnergyCategoryTypePicker.svelte';

	const dispatch = createEventDispatcher();

	let selected: ApplianceType | undefined;

	const selectType = (type: ApplianceType): void => {
		selected = type;
		dispatch('toggler', selected);
	};
</script>

<EnergyCategoryTypePicker selectedUsage={selected?.usage} on:select={(e) => selectType(e.detail)} />
